import { css } from 'styled-components';

const focusOutline = /*#__PURE__*/css(["outline:", ";outline-offset:", ";"], ({
  theme
}) => `${theme.focusVisible.outlineWidth} ${theme.focusVisible.outlineStyle} ${theme.focusVisible.outlineColor}`, ({
  theme
}) => theme.focusVisible.outlineOffset);

export { focusOutline as f };
//# sourceMappingURL=focusOutline-DNwtedBp.js.map
